import removeSupplierDialogCtrl from "./removeSupplierDialog/removeSupplierDialog.controller";
import removeSupplierDialogView from "./removeSupplierDialog/removeSupplierDialog.html";

class Controller {
  constructor($mdDialog, $injector, Events, ride) {
    this.$mdDialog = $mdDialog;
    this.loading = false;
    this.Ride = $injector.get("Ride");
    this.Events = Events;
    this.confirmEvent = Events.getUpdateEvent("confirmEventTransfer");
    this.errorEvent = Events.eventsType.onShowErrorNotification;
    this.successEvent = Events.eventsType.onShowSuccessNotification;
    this.ride = ride;
    this.RideTransforms = $injector.get("RideTransforms");
  }
  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));
  }

  confirm() {
    this.$mdDialog.hide({
      reason: this.reason,
      remove_mapping: this.removeMapping || false,
    });
  }

  onRemoveContractorChange() {
    if (this.removeMapping) {
      const removeMapping = this.$mdDialog.show({
        controller: removeSupplierDialogCtrl,
        controllerAs: "$ctrl",
        template: removeSupplierDialogView,
        clickOutsideToClose: true,
        autoWrap: true,
        skipHide: true,
        multiple: true,
        locals: {
          ride: this.ride,
        },
      });
      removeMapping.then((data) => {
        this.removeMapping = data.removeMapping;
      });
      removeMapping.catch(() => {
        this.removeMapping = false;
      });
    }
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/unAssignCaptain/unAssignCaptain.controller.js